import type { DataGridFilterState, DataGridSortingState } from '@ibsys/kit';
import { DataGrid, Spinner } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { PhraseAuditItem } from '@/entities/phrases';
import { PHRASES_PAGE_SIZE_OPTIONS } from '../model/constants';
import { usePhraseColumns } from './usePhraseColumns';

type Props = {
  /** Реплики текущей страницы перечня */
  phrases: PhraseAuditItem[];
  /** Всего реплик под отбором — без учёта окна */
  totalCount: number;
  /** Текущая страница, 0-based */
  page: number;
  pageSize: number;
  sorting: DataGridSortingState;
  filters: DataGridFilterState;
  /** Первая страница перечня ещё не пришла */
  isLoading: boolean;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  onSortingChange: (sorting: DataGridSortingState) => void;
  onFiltersChange: (filters: DataGridFilterState) => void;
};

/**
 * Презентер раздела «Аудит аудио»: заголовок и постраничный перечень реплик
 * с серверными отбором и порядком.
 */
export const AudioAuditTable: FC<Props> = ({
  phrases,
  totalCount,
  page,
  pageSize,
  sorting,
  filters,
  isLoading,
  onPageChange,
  onPageSizeChange,
  onSortingChange,
  onFiltersChange,
}) => {
  const { t } = useTranslation(['audioAudit']);
  const columns = usePhraseColumns();

  return (
    <>
      <h1 className="text-2xl font-semibold">{t('audioAudit:title')}</h1>
      <div className="flex-1 min-h-0" data-testid="audio-audit-table">
        <DataGrid
          className="h-full w-full"
          columns={columns}
          dataSource={{
            mode: 'paginated',
            totalCount,
            page,
            pageSize,
            onPageChange,
            onPageSizeChange,
            pageSizeOptions: PHRASES_PAGE_SIZE_OPTIONS,
            data: phrases,
          }}
          getRowId={(row) => String(row.id)}
          sorting={sorting}
          onSortingChange={onSortingChange}
          filters={filters}
          onFiltersChange={onFiltersChange}
          enableColumnResizing
          emptyState={
            isLoading ? (
              <Spinner className="size-6" />
            ) : (
              <span className="text-muted-foreground">{t('audioAudit:empty')}</span>
            )
          }
        />
      </div>
    </>
  );
};
